import { LogoLockup } from '@/components/primitives/LogoLockup';
import { Mail } from 'lucide-react';

export function Footer() {
  const cities = ['Ottawa', 'Montreal', 'Toronto', 'Calgary'];
  
  const footerLinks = {
    product: [
      { label: 'How it works', href: '/#how-it-works' },
      { label: 'Pricing', href: '/#pricing' },
      { label: 'Storm Pass', href: '/storm-pass' },
      { label: 'Download app', href: '/#download' },
    ],
    operators: [
      { label: 'Become an operator', href: '/operators' },
      { label: 'Operator app', href: '/operators#app' },
      { label: 'Earnings', href: '/operators#earnings' },
      { label: 'Requirements', href: '/operators#requirements' },
    ],
    company: [
      { label: 'About', href: '#' },
      { label: 'FAQ', href: '/faq' },
      { label: 'Support', href: '#' },
      { label: 'Contact', href: '#' },
    ],
    legal: [
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Service', href: '#' },
      { label: 'Security', href: '#' },
    ],
  };

  return (
    <footer className="bg-gradient-to-b from-neutral-900 to-neutral-950 text-white">
      <div className="container-wide mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-12 mb-12">
          {/* Logo + Tagline */}
          <div className="md:col-span-2">
            <LogoLockup size="default" />
            <p className="text-neutral-300 mt-5 text-base font-medium leading-relaxed max-w-sm">
              Never shovel again. On-demand snow clearing that actually works—in minutes, not hours.
            </p>
            <div className="mt-6">
              <a href="mailto:hello@snowblowr.com" className="inline-flex items-center gap-2 text-base text-neutral-400 hover:text-accent-500 transition-colors font-medium">
                <Mail className="h-5 w-5" />
                hello@snowblowr.com
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-black text-base mb-5 text-white">Product</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-neutral-400 hover:text-white transition-colors font-medium">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-black text-base mb-5 text-white">Operators</h3>
            <ul className="space-y-3">
              {footerLinks.operators.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-neutral-400 hover:text-white transition-colors font-medium">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-black text-base mb-5 text-white">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-neutral-400 hover:text-white transition-colors font-medium">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-black text-base mb-5 text-white">Legal</h3>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-neutral-400 hover:text-white transition-colors font-medium">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Cities */}
        <div className="border-t border-neutral-800 pt-10 mb-10">
          <div className="flex flex-wrap items-center gap-6">
            <span className="text-sm text-neutral-500 font-bold uppercase tracking-wider">Now serving:</span>
            {cities.map((city) => (
              <span key={city} className="text-base font-black text-white">{city}</span>
            ))}
            <span className="px-4 py-1.5 bg-accent-500/20 border border-accent-500/30 text-accent-500 rounded-full text-xs font-black uppercase tracking-wider">
              + More Cities Coming Soon
            </span>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-neutral-800 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm text-neutral-400 font-medium">
            © {new Date().getFullYear()} SNOWBLOWR. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <select className="bg-neutral-800 text-sm rounded-xl px-4 py-2 border-2 border-neutral-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 transition-all font-bold">
              <option>EN</option>
              <option>FR</option>
            </select>
          </div>
        </div>
      </div>
    </footer>
  );
}

